import { Button, Heading, Inline, Stack, Text } from '@cortex/ui';
import { useNavigate } from '@tanstack/react-router';
import { FolderKanban, Plus } from 'lucide-react';

import { useAuthStore } from '@/store/auth-store';

function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';
  return 'Good evening';
}

function getFirstName(name?: string): string {
  if (!name) return '';
  return name.split(' ')[0] ?? name;
}

function formatDate(): string {
  return new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
}

export function DashboardGreeting() {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const firstName = getFirstName(user?.name);
  const greeting = getGreeting();

  return (
    <Inline justify="between">
      <Stack gap="none">
        <Heading level={1} className="text-2xl font-semibold">
          {greeting}
          {firstName ? `, ${firstName}` : ''}
        </Heading>
        <Text color="muted" size="sm">
          {formatDate()} &middot; Here&apos;s what&apos;s happening
        </Text>
      </Stack>
      <Inline gap="sm">
        <Button
          variant="default"
          size="sm"
          onClick={() => navigate({ to: '/requests/new' })}
        >
          <Plus className="mr-1.5 h-4 w-4" />
          New Request
        </Button>
        <Button
          variant="secondary"
          size="sm"
          onClick={() => navigate({ to: '/projects' })}
        >
          <FolderKanban className="mr-1.5 h-4 w-4" />
          Projects
        </Button>
      </Inline>
    </Inline>
  );
}
